// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { useFormikContext } from 'formik'
import { ComponentProps } from 'react'
import styled from 'styled-components'

import { Button } from '@syconium/little-miss-figgy/dist/components/Button/Button'
import { LoadingSpinner } from '@syconium/little-miss-figgy/dist/components/LoadingSpinner/LoadingSpinner'

const FormSubmitSpinner = styled(
  ({ size = '20px', ...rest }: ComponentProps<typeof LoadingSpinner>) => {
    return <LoadingSpinner size={size} {...rest} />
  }
)`
  position: absolute;
  inset: auto auto auto auto;
`

export const FormSubmitContent = ({
  children,
  isSubmitting,
  submittingLabel,
}: {
  children?: React.ReactNode
  isSubmitting: boolean
  submittingLabel: string
}) => {
  return (
    <>
      <span style={isSubmitting ? { opacity: 0 } : {}}>{children}</span>
      {isSubmitting ? <FormSubmitSpinner label={submittingLabel} /> : null}
    </>
  )
}

export const FormSubmit = styled(
  ({
    children,
    className,
    submittingLabel,
  }: {
    className?: string
    children: React.ReactNode
    submittingLabel: string
  }) => {
    const formContext = useFormikContext()
    return (
      <Button className={className} type='submit'>
        <FormSubmitContent
          children={children}
          submittingLabel={submittingLabel}
          isSubmitting={formContext.isSubmitting}
        />
      </Button>
    )
  }
)`
  position: relative;
`
